import React from 'react';
import { Text, Card, Icon } from '../../../common/components';
import { useModal } from '../../../common/components/Modal/useModal';
import { BuildingLogModal } from './BuildingLogModal';
import { formatDateTime } from '../../../common/utils/Date/Date';
import { getRegistryIcon, getRegistryTitle } from '../../utils/registryHelpers';
import { useAppSelector } from '../../../common/hooks';
import { selectSecurity } from '../../../common/store/securitySlice';
import { parseBuildingLogData, generateChangeSummary } from '../../utils/buildingLog/BuildingLogDataParser';

interface DiffItem {
  key: string;
  type: string;
  label: string;
  current: string;
  previous: string;
}

interface LogData {
  diff?: DiffItem[];
  [key: string]: unknown;
}

export interface BuildingLogItem {
  id: string;
  type: string;
  message: string;
  typeGroup: string;
  messageType: string;
  reference: string;
  recordedAt: string;
  createdAt: string;
  data: LogData;
  isChanged: boolean;
  units?: Array<{id: string; label: string; [key: string]: unknown}>;
  profiles?: Array<{
    id: string; 
    firstName?: string; 
    lastName?: string; 
    company?: string; 
    companyId?: string;
    email?: string;
    phone?: string;
    birthDate?: string;
    isUser?: boolean;
    birthNumber?: string;
    [key: string]: unknown;
  }>;
}

interface BuildingLogProps {
  log: BuildingLogItem;
}

export const BuildingLog: React.FC<BuildingLogProps> = ({ log }) => {
  const [isModalShown, toggleModal] = useModal();
  const security = useAppSelector(selectSecurity).ui;
  const hasSubscription = security.tokens?.filter((item) => item.type === 'building-subscription').length || 0;

  // Generování shrnutí změn
  const diffItems = parseBuildingLogData(log.data, log.profiles);
  const changeSummary = generateChangeSummary(diffItems, log.units);

  return (
    <>
      {log.isChanged ? (
        <>
          <Card
            className={`BuildingLogItem BuildingLogItem--change BuildingLogItem--${log.messageType.toLowerCase()}`}
            onClick={hasSubscription > 0 ? toggleModal : undefined}
          >
            <Text size="body-medium" weight='400' className="BuildingLogItem__msg">
              <span dangerouslySetInnerHTML={{ __html: changeSummary }} />
            </Text>
            <Icon name={getRegistryIcon(log.typeGroup)} color='Neutral600' className="BuildingLogItem__icon" />
          </Card>

          {hasSubscription > 0 && (
            <BuildingLogModal
              log={log}
              isShown={isModalShown}
              onHide={toggleModal}
            />
          )}
        </>
      ) : (
        <div className={`BuildingLogItem BuildingLogItem--noChange`}>
          <Text size="body-small" weight='400' color="Neutral600" className='mr-1'>{formatDateTime(log.recordedAt)}</Text>
          <Text size="body-small" weight='400' color="Neutral600" className=' BuildingLogItem__msg'>Kontrola "{getRegistryTitle(log.typeGroup)}" bez nalezených změn</Text>
        </div>
      )}
    </>
  );
};

export default BuildingLog;
